export const loginTabs = [
  { id: 1, title: "Bank customer" },
  { id: 2, title: "Not a Bank customer" },
];

export const customerType = {
  BANK_CUSTOMER: 1,
  NON_CUSTOMER: 2,
};
